/* cro-product-card.js
 *
 * Quick-add + colour-swatch behaviour for the site product card.
 *
 * WHY THIS IS AN ASSET AND NOT AN INLINE <script> IN cro-product-card.liquid:
 * "Complete the Look" (sections/cro-recommendations.liquid) fetches Shopify's recommendations,
 * parses them with DOMParser and appendChild's the result. A <script> tag introduced that way
 * NEVER EXECUTES. So the card's inline script never ran on the product page, window.__cpcInit
 * stayed false, and nothing was bound: colour swatches did not swap the photo and Quick add did
 * nothing at all. It worked on collection pages only because those cards are server-rendered.
 *
 * As a separate file loaded by the PARENT page it runs once, and because every handler below is
 * delegated from `document` it also covers cards injected later by AJAX.
 *
 * Loaded with `defer` by any section that renders the card. The __cpcInit guard at the top makes
 * a second load harmless.
 */
(function(){
  if (window.__cpcInit) return; window.__cpcInit = true;

  function variantsOf(qa){ try{ return JSON.parse(qa.querySelector('[data-cpc-variants]').textContent); }catch(e){ return []; } }
  function openCart(){
    try{ document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('cart:build',{bubbles:true})); }catch(e){}
    // Prefer the explicit OPEN over the blind toggle, so a rapid second tap can never close the drawer.
    setTimeout(function(){ try{ if(typeof window.upcartOpenCart==='function'){ window.upcartOpenCart(); } else if(typeof window.UpcartToggleCart==='function'){ window.UpcartToggleCart(); } }catch(e){} }, 150);
  }
  // "December 15, 2026" -> "Dec 15". A date more than a day in the past returns '' (same passed-date guard as the PDP's
  // preDateOf in cro-urgency), so a stale cached card never prints a date that has already gone by.
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function shortDate(po){
    if(!po) return '';
    var t = Date.parse(po);
    if(isNaN(t)) return String(po);
    if(t < Date.now() - 86400000) return '';
    var d = new Date(t); return MON[d.getMonth()] + ' ' + d.getDate();
  }
  // Per-size date line under each chip (2026-10-04). Styles are injected once from here because the cart drawer's upsell
  // rows use these chips on pages that never load cro-product-card.css.
  function ensureDateCss(){
    if(document.getElementById('cpc-qa-d-css')) return;
    var s = document.createElement('style'); s.id = 'cpc-qa-d-css';
    s.textContent = '.cpc-qa-chip__d{display:block;margin-top:2px;font-size:9.5px;line-height:1.1;font-weight:600;letter-spacing:0;text-transform:none;text-decoration:none;color:#17347a;white-space:nowrap}'
      + '.cpc-qa-chip__d--now{color:#555}'
      + '.cpc-qa-chip:hover .cpc-qa-chip__d{color:inherit;opacity:.85}'
      + ':is(#site-cart-sidebar,.fst-cart-page) .fst-rec .cpc-qa-chip:has(.cpc-qa-chip__d){padding-top:5px;padding-bottom:5px;line-height:1.05}'
      + '.cpc-qa-perk{display:block;margin-top:3px;font-weight:600;color:#17347a}'
      + '.cpc-qa-perk b{font-weight:700}'
      + '.cpc-qa-perk s{margin-left:4px;font-weight:400;color:#8a8a8a}';
    (document.head || document.documentElement).appendChild(s);
  }
  function setChipDate(chip, txt, now){
    var el = chip.querySelector('[data-cpc-qa-d]');
    if(!txt){ if(el) el.parentNode.removeChild(el); return; }
    if(!el){ ensureDateCss(); el = document.createElement('span'); el.className = 'cpc-qa-chip__d'; el.setAttribute('data-cpc-qa-d', ''); chip.appendChild(el); }
    if(el.textContent !== txt) el.textContent = txt;
    el.classList.toggle('cpc-qa-chip__d--now', !!now);
  }
  // Claim test B (2026-10-04): money in the shopper's currency. The variants JSON carries cents in the presentment currency
  // ("p" price, "pk" pre-order price), the same numbers the cart and checkout use.
  function money(c){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    if (cur === 'USD') return '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(c / 100).replace(/\.00(?!\d)/, ''); } catch(e){ return (c / 100).toFixed(2); }
  }
  // Pre-order price line under the note: "Pre-order price $62.10 $69" when every pre-order size of this colour gets the same
  // perk, "... on S, M, L" when only some do, "5% off on ..." when the sizes are priced differently. Nothing without a perk.
  function perkLine(rows){
    var pre = rows.filter(function(r){ return r.ok && r.pre; }), pk = pre.filter(function(r){ return r.pk; });
    if(!pk.length) return null;
    var vals = []; pk.forEach(function(r){ if(vals.indexOf(r.pk) < 0) vals.push(r.pk); });
    var sizes = pk.map(function(r){ return r.chip.getAttribute('data-size') || ''; }).filter(Boolean).join(', ');
    var el = document.createElement('span'); el.className = 'cpc-qa-perk';
    // 2026-10-19 (snippets/cro-soon): sizes shipping on a landing-now date are not called pre-orders
    var allSoon = pk.some(function(r){ return r.sn; });
    if(vals.length === 1){
      var reg = pk[0].p;
      el.appendChild(document.createTextNode(allSoon ? '5% off ' : 'Pre-order price '));
      var b = document.createElement('b'); b.textContent = money(vals[0]); el.appendChild(b);
      if(reg && reg > vals[0]){ var st = document.createElement('s'); st.textContent = money(reg); el.appendChild(st); }
      if(pk.length < pre.length && sizes) el.appendChild(document.createTextNode(' on ' + sizes));
    } else {
      el.textContent = (allSoon ? '5% off' : 'Pre-order price: 5% off') + (pk.length < pre.length && sizes ? ' on ' + sizes : '');
    }
    return el;
  }
  // The card's "Pre-order sizes 5% off" line (cro-product-card.liquid) follows the colour on show.
  function paintCardPerk(card, qa){
    var pl = card ? card.querySelector('[data-cpc-perk]') : null; if(!pl || !qa) return;
    var data = variantsOf(qa), cpos = +qa.getAttribute('data-cpc-cpos')||0, color = qa.getAttribute('data-cpc-color');
    var pkv = data.filter(function(v){ return (!cpos || v['o'+cpos] === color) && v.pk; }), on = pkv.length > 0;
    var allSoon = on && !!window.__fstSoonOf && pkv.some(function(v){ return v.po && window.__fstSoonOf(v.po); });
    var txt = allSoon ? '5% off select sizes' : 'Pre-order sizes 5% off';
    if(pl.textContent !== txt) pl.textContent = txt;
    pl.style.display = on ? '' : 'none';
  }
  function flash(qa, po){
    var f = qa.querySelector('[data-cpc-qa-flash]'), tray = qa.querySelector('[data-cpc-qa-tray]');
    if(tray) tray.hidden = true;
    // The confirmation carries the date of the size that was just added, never another size's date.
    var sd = po ? shortDate(po) : '', sn = (po && window.__fstSoonOf) ? window.__fstSoonOf(po) : '';
    if(f){ f.textContent = sn ? ('Added to cart · ships ' + sn) : (po ? ('Pre-order added' + (sd ? (' · ships by ' + sd) : '')) : 'Added to cart'); f.classList.toggle('cpc-qa-flash--preorder', !!po); f.hidden = false; setTimeout(function(){ f.hidden = true; }, po ? 2600 : 1600); }
  }
  function refreshSizes(qa){
    var data = variantsOf(qa), cpos=+qa.getAttribute('data-cpc-cpos')||0, spos=+qa.getAttribute('data-cpc-spos')||0, color=qa.getAttribute('data-cpc-color');
    // 2026-10-04 fix: every size keeps its OWN date. Before, one shared preDate took the last dotted size's date, so the
    // Royal Blue hoodie card said "ship December 15" for S, M and L, which ship Oct 20.
    var rows = [], dates = [], anyPre = false, soonN = 0, soonL = '';
    qa.querySelectorAll('[data-cpc-qa-size]').forEach(function(chip){
      var size = chip.getAttribute('data-size');
      var match = data.filter(function(v){ return (!cpos||v['o'+cpos]===color)&&(!spos||v['o'+spos]===size)&&v.av; })[0];
      var ok = !!match;
      // Sold-out chips stay CLICKABLE on purpose. A disabled <button> fires no click event, so the
      // shopper could not tell us they wanted it. Clicking one now opens the restock modal instead.
      chip.disabled = false;
      chip.classList.toggle('cpc-qa-chip--soldout', !ok);
      chip.setAttribute('data-soldout', ok ? '0' : '1');
      var pre = !!(match && match.po);
      var sd = pre ? shortDate(match.po) : '';
      chip.classList.toggle('cpc-qa-chip--preorder', pre);
      if (!ok) chip.setAttribute('title', 'Sold out. Tap to get notified when it is back.');
      else if(pre){ var sn = window.__fstSoonOf ? window.__fstSoonOf(match.po) : ''; if(sn){ soonN++; soonL = sn; } chip.setAttribute('title', sn ? ('Ships ' + sn) : (sd ? ('Pre-order · ships by ' + sd) : 'Pre-order')); anyPre = true; if(sd && dates.indexOf(sd) < 0) dates.push(sd); }
      else { chip.removeAttribute('title'); }
      rows.push({ chip: chip, ok: ok, pre: pre, sd: sd, sn: (pre && window.__fstSoonOf) ? window.__fstSoonOf(match.po) : '', pk: (match && pre && match.pk) ? +match.pk : 0, p: match ? +match.p || 0 : 0 });
    });
    // Date under each size only when this colour has a pre-order size: "Oct 20", "Dec 15", or "Now" for an in-stock size.
    // Sold-out sizes get none. A colour that is fully in stock keeps the plain chips.
    rows.forEach(function(r){
      if(!anyPre || !r.ok){ setChipDate(r.chip, ''); return; }
      if(r.pre){ setChipDate(r.chip, r.sd, false); } else { setChipDate(r.chip, 'Now', true); }
    });
    // Spell out what the dot means, for the colour currently selected on this card.
    var anySoldOut = !!qa.querySelector('[data-cpc-qa-size][data-soldout="1"]');
    var note = qa.querySelector('[data-cpc-qa-note]');
    if(note){
      // Pre-order wording wins when both apply: a date is more useful than a maybe.
      if(anyPre){
        note.textContent = (dates.length === 1 && soonN > 0) ? ('Dotted sizes ship ' + soonL) : dates.length === 1 ? ('Dotted sizes are pre-order · ship by ' + dates[0])
          : (dates.length > 1 ? 'Dotted sizes are pre-order · each ships by the date under it' : 'Dotted sizes are pre-order');
        note.classList.add('cpc-qa-note--preorder'); note.hidden = false;
        var pl = perkLine(rows); if(pl){ ensureDateCss(); note.appendChild(pl); }
      } else if(anySoldOut){
        note.textContent = 'Greyed sizes are sold out · tap one to get notified';
        note.classList.remove('cpc-qa-note--preorder'); note.hidden = false;
      } else { note.textContent = ''; note.classList.remove('cpc-qa-note--preorder'); note.hidden = true; }
    }
  }
  // The cart drawer renders its upsell trays already open (pinned), so nothing triggers the first paint of the pre-order
  // dots + note there; cro-cart.js calls this after the rows land (2026-09-26).
  window.cpcRefreshSizes = refreshSizes;
  window.cpcPaintPerk = paintCardPerk;  // the homepage carousel (sections/cro-collection) has its own swatch handler
  function resolve(qa, size){
    var data = variantsOf(qa), cpos=+qa.getAttribute('data-cpc-cpos')||0, spos=+qa.getAttribute('data-cpc-spos')||0, color=qa.getAttribute('data-cpc-color');
    var m = data.filter(function(v){ return (!cpos||v['o'+cpos]===color)&&(!spos||v['o'+spos]===size)&&v.av; })[0];
    if(!m && !size){ m = data.filter(function(v){ return v.av; })[0]; }
    return m;
  }
  function add(qa, v){
    if(!v || !v.id) return;
    if(qa.dataset.cpcAdding === '1') return;  // in-flight guard: ignore rapid double-taps so we never add qty 2
    qa.dataset.cpcAdding = '1';
    try { document.dispatchEvent(new CustomEvent('fst:adding')); } catch(e){}  // the cart drawer opens right away with a progress bar
    var openBtn = qa.querySelector('[data-cpc-qa-open]'); if(openBtn) openBtn.classList.add('is-loading');
    var item = { id: v.id, quantity: 1 };
    if(v.po){ item.properties = { 'Ships by': v.po }; }  // pre-order marker: mirrors the PDP so every add path is consistent
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){ return r.json(); })
      .then(function(){ if(openBtn) openBtn.classList.remove('is-loading'); flash(qa, v.po); openCart(); })
      .catch(function(){ if(openBtn) openBtn.classList.remove('is-loading'); })
      .then(function(){ qa.dataset.cpcAdding = ''; });  // clear guard whether the add succeeded or failed
  }

  document.addEventListener('click', function(e){
    // 1) color swatch -> swap photo + set active color + refresh size availability
    var sw = e.target.closest('[data-cpc-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('.cpc-card, .fst-rec'); if (!card) return;  // .fst-rec = the cart drawer's upsell row
      var img = card.querySelector('[data-cpc-img]');
      if (img) { var s = sw.getAttribute('data-img'), ss = sw.getAttribute('data-srcset'); if (s) img.setAttribute('src', s); if (ss) img.setAttribute('srcset', ss); }
      var vid = sw.getAttribute('data-variant');
      if (vid) { card.querySelectorAll('.cpc-media-link, .cpc-title').forEach(function(a){ if (a.getAttribute('href')) a.setAttribute('href', a.getAttribute('href').split('?')[0] + '?variant=' + vid); }); }
      // Colour-scoped sale (snippets/cro-sale.liquid scope "notcolor"): the swatch carries its colour's own price and
      // badge, so the card can never show a sale price for a colour the cart charges in full. Other swatches have
      // neither attribute and are left alone.
      var saleOver = document.documentElement.classList.contains('fst-sale-over');  // cached page, sale has ended
      var ph = saleOver ? null : sw.getAttribute('data-price-html');
      if (ph !== null) { var pe = card.querySelector('.cpc-price'); if (pe) pe.innerHTML = ph; }
      if (!saleOver && sw.hasAttribute('data-sale-badge')) {
        var bd = card.querySelector('[data-cpc-badge]');
        if (bd) { var bt = sw.getAttribute('data-sale-badge') || '', bb = bd.getAttribute('data-base') || ''; bd.textContent = bt || bb; bd.classList.toggle('cpc-badge--sale', !!bt); bd.hidden = !(bt || bb); }
      }
      card.querySelectorAll('[data-cpc-swatch]').forEach(function(x){ x.classList.remove('is-active'); });
      sw.classList.add('is-active');
      var qaEl = card.querySelector('[data-cpc-qa]');
      if(qaEl){ qaEl.setAttribute('data-cpc-color', sw.getAttribute('aria-label')||''); var tr=qaEl.querySelector('[data-cpc-qa-tray]'); if(tr && !tr.hidden) refreshSizes(qaEl); paintCardPerk(card, qaEl); }
      try { card.dispatchEvent(new CustomEvent('cpc:color', { bubbles: true, detail: { color: sw.getAttribute('aria-label') || '' } })); } catch(err){}  // cart drawer rows re-price on this
      return;
    }
    // 2) "Quick add" -> reveal the size tray (or add straight away if there's nothing to choose)
    var open = e.target.closest('[data-cpc-qa-open]');
    if (open) {
      e.preventDefault();
      var qa = open.closest('[data-cpc-qa]'); if(!qa) return;
      var tray = qa.querySelector('[data-cpc-qa-tray]');
      document.querySelectorAll('[data-cpc-qa-tray]:not([data-cpc-pinned])').forEach(function(t){ if(t!==tray) t.hidden = true; });
      if(tray){ var willOpen = tray.hidden; tray.hidden = !willOpen; if(willOpen) refreshSizes(qa); }
      return;
    }
    // 3) size chip -> resolve + add
    var chip = e.target.closest('[data-cpc-qa-size]');
    if (chip && chip.getAttribute('data-soldout') === '1') {
      // Sold out -> offer the restock signup rather than doing nothing.
      e.preventDefault();
      var sqa = chip.closest('[data-cpc-qa]');
      var scard = chip.closest('.cpc-card, .cc-card, .fst-rec');
      var titleEl = scard ? scard.querySelector('.cpc-title, .cc-name, .fst-rec__title') : null;
      // Hand over the exact sold-out variant so the subscription is for the size they tapped,
      // not whatever the card happened to render with.
      var want = null;
      if (sqa) {
        var d = variantsOf(sqa), cp = +sqa.getAttribute('data-cpc-cpos')||0, sp = +sqa.getAttribute('data-cpc-spos')||0;
        var col = sqa.getAttribute('data-cpc-color'), sz = chip.getAttribute('data-size');
        want = d.filter(function(v){ return (!cp||v['o'+cp]===col)&&(!sp||v['o'+sp]===sz); })[0];
      }
      if (window.fstRestock) {
        window.fstRestock.open({
          variantId: want ? want.id : null,
          productName: titleEl ? (titleEl.textContent||'').trim() : null
        });
      }
      var st = sqa ? sqa.querySelector('[data-cpc-qa-tray]') : null; if (st) st.hidden = true;
      return;
    }
    if (chip && !chip.disabled) {
      e.preventDefault();
      var qa = chip.closest('[data-cpc-qa]'); if(!qa) return;
      var m = resolve(qa, chip.getAttribute('data-size'));
      if(m) add(qa, m);
      return;
    }
    // 4) "Add to cart" chip (product with no size option) -> add
    var addc = e.target.closest('[data-cpc-qa-add]');
    if (addc) {
      e.preventDefault();
      var qa = addc.closest('[data-cpc-qa]'); if(!qa) return;
      var m = resolve(qa, null);
      if(m) add(qa, m);
      return;
    }
    // 5) click anywhere else -> close open trays
    // pinned trays (the cart drawer's upsell rows) stay open: hiding them made the drawer's sizes untappable
    if(!e.target.closest('[data-cpc-qa]')){ document.querySelectorAll('[data-cpc-qa-tray]:not([data-cpc-pinned])').forEach(function(t){ t.hidden = true; }); }
  }, false);
})();

/* 2026-10-15 model caption on every tile ("5'9" · wearing L"). The span [data-cpc-cap] carries two answers:
 *  data-alt = the alt text of the photo on show ("Pink | MJ is 5'9" wearing size L"), parsed here;
 *  data-v   = the clip's model from custom.card_videos ({"h":"5'9\"","s":"L"}), used once that clip is playing.
 * A colour swatch tap swaps to that colour's photo alt (the clip stops on a swatch tap). An alt with no height,
 * or with two people in it, shows nothing. Separate IIFE so it never depends on the __cpcInit guard above. */
(function(){
  if (window.__cpcCap) return; window.__cpcCap = true;
  var RX = /(\d)\s*['’]\s*(\d{1,2})\s*(?:["”]|'')?.{0,40}?\b(?:wear(?:ing|s)|in)\s+(?:an?\s+|size\s+)*(XXS|XS|S|M|L|XL|XXL|2XL|3XL|XXXL|Small|Medium|Large)\b/i;
  var SZ = { small: 'S', medium: 'M', large: 'L' };
  function fromAlt(a){
    if (!a) return '';
    var n = a.match(/\d\s*['’]\s*\d/g); if (!n || n.length !== 1) return '';
    var m = a.match(RX); if (!m) return '';
    var z = SZ[m[3].toLowerCase()] || m[3].toUpperCase();
    return m[1] + '\'' + m[2] + '" · wearing ' + z;
  }
  function put(c, t){ c.textContent = t; c.hidden = !t; }
  // The caption follows whatever is on screen: the clip's model only while the clip is showing (.is-on), else the
  // photo's. A paused or stalled clip fades back to the photo, and so does the caption.
  function arm(c){
    c.setAttribute('data-cpc-cap-on', '');
    c._p = fromAlt(c.getAttribute('data-alt'));
    put(c, c._p);
    var v = c.getAttribute('data-v'), card = c.closest('.cpc-card, .cc-card');
    var vid = v && card && card.querySelector('video[data-cpc-vid]');
    if (vid) new MutationObserver(function(){ put(c, vid.classList.contains('is-on') && !vid.dataset.off ? v : c._p); })
      .observe(vid, { attributes: true, attributeFilter: ['class', 'data-off'] });
  }
  function init(){
    document.querySelectorAll('[data-cpc-cap]:not([data-cpc-cap-on])').forEach(arm);
    // the perk line's wording follows snippets/cro-soon for the colour on show (Liquid renders the pre-order wording)
    document.querySelectorAll('[data-cpc-perk]').forEach(function(pl){ var card = pl.closest('.cpc-card, .cc-card'), qa = card && card.querySelector('[data-cpc-qa]'); if(qa){ try{ paintCardPerk(card, qa); }catch(e){} } });
  }
  document.addEventListener('click', function(e){
    var sw = e.target.closest('[data-cpc-swatch], [data-cc-swatch]'); if (!sw) return;
    var card = sw.closest('.cpc-card, .cc-card'); var c = card && card.querySelector('[data-cpc-cap]'); if (!c) return;
    c._p = fromAlt(sw.getAttribute('data-alt')); put(c, c._p);
  }, true);
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(init, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
